/*
 * Created Date: Wednesday July 10th 2019
 * Author: Buddhika Jayawardhana
 * Copyright (c) 2019 Meetrix.I0
 */

import DetectRTC from 'detectrtc';
import { config } from '../../config';
import {
  ProfileType,
  getMimeWithCodecs,
} from '../constants/mediaFormatProfiles';

// Returns true if the browser supports GetDisplayMedia Api
export async function isSupported(browserName: string, browserVersion: number) {
  if (browserName === 'Chrome' && browserVersion > 72) {
    return { supported: true, message: 'Supported' };
  }
  if (browserName === 'Chrome' && browserVersion <= 72) {
    return {
      supported: false,
      message:
        'We only support Chrome version 73 and above. Please update your browser',
    };
  }
  if (browserName === 'Firefox' && browserVersion > 66) {
    return { supported: true, message: 'Supported' };
  }
  if (browserName === 'Firefox' && browserVersion <= 66) {
    return {
      supported: true,
      message:
        'We only support Firefox version 67 and above. Please update your browser',
    };
  }
  if (browserName === 'Safari') {
    return {
      supported: false,
      message: 'Oops! Safari wont work. Please use Chrome or Firefox',
    };
  }
  if (browserName === 'Opera') {
    return { supported: true, message: 'Supported' };
  }
  return { supported: false, message: 'Unsupported Browser' };
}

export const defaultFormatProfilePreference = [
  'mp4',
  'mkv',
  'webm',
] as ProfileType[];

export function getMediaRecorderSupportedFormatProfile(
  formatProfilePreference = defaultFormatProfilePreference,
  streams: Parameters<typeof getMimeWithCodecs>[1] = {
    audio: true,
    video: true,
  }
): ProfileType {
  for (let i = 0; i < formatProfilePreference.length; i += 1) {
    const profile = formatProfilePreference[i];
    const mime = getMimeWithCodecs(profile, streams);
    const mediaRecorderSupported = MediaRecorder.isTypeSupported(mime);
    if (mediaRecorderSupported) {
      return profile;
    }
  }

  return 'webm';
}

export async function checkBrowserCompatibility() {
  const supportedStatus = await isSupported(
    DetectRTC.browser.name,
    Number(DetectRTC.browser.version)
  );
  return {
    name: DetectRTC.browser.name,
    version: DetectRTC.browser.version,
    ...supportedStatus,
  };
}

export function getUserAgentDetails() {
  return {
    app: { version: config.version, commit: config.commit },
    locale: {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // OS language vs. browser language
      language:
        navigator.language || Intl.DateTimeFormat().resolvedOptions().locale,
    },
    browser: {
      name: DetectRTC.browser.name,
      version: DetectRTC.browser.fullVersion,
    },
    os: { name: DetectRTC.osName, version: DetectRTC.osVersion },
    screen: {
      resolution: DetectRTC.displayResolution,
      aspectRatio: DetectRTC.displayAspectRatio,
    },
  };
}
